import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vbqxxxsbvs: FaireBrandEntity = {
  token: "b_vbqxxxsbvs",
  type: "brand",
  name: "Mercado Famous",
  avatarUrl:
    "https://cdn.faire.com/fastly/3e55db3b9fe28841aa8144e090ab987185db63eb0da3955fad9315dc60475911.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/eb64a1c1741c21ce7a6eae704f0507fc972c0d701da20d48a4b06fbcd3deebff.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3e55db3b9fe28841aa8144e090ab987185db63eb0da3955fad9315dc60475911.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/eb64a1c1741c21ce7a6eae704f0507fc972c0d701da20d48a4b06fbcd3deebff.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 7,
  isInsider: true,
  description:
    "We are Spaniards, we are Chinese, and we are food lovers. It all started when both our grandparents moved to Spain and opened restaurants. We grew up fascinated by the local cuisine, especially Spanish charcuterie. In Spain, charcuterie is considered a national treasure but also something to eat everyday—on its own or as a cooking ingredient—as we did.\n\nNearly 20 years ago, we moved to the U.S., where high-quality Spanish charcuterie is hard to find. We miss the flavors of these wonderful meats, but even more we miss sitting with friends over plates of jamon and glasses of vermouth and just talking, laughing, and slowing down. That’s the Spanish way, and that’s what we’re sharing with you.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:47.076Z",
    importedBy: "entity-db-cli",
  },
};
